<template>
  <div v-if="dialogState.open" class="global-dialog" @click.self="onCancel">
    <div class="global-dialog-card">
      <p class="global-dialog-message">{{ dialogState.message }}</p>
      <div class="global-dialog-actions">
        <button
          v-if="dialogState.type === 'confirm'"
          type="button"
          class="global-dialog-btn global-dialog-btn--ghost"
          @click="onCancel"
        >취소</button>
        <button
          type="button"
          class="global-dialog-btn global-dialog-btn--primary"
          @click="onConfirm"
        >확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import { dialogState } from '@/plugins/dialog'

export default {
  name: 'GlobalDialog',
  data() {
    return { dialogState }
  },
  methods: {
    onConfirm() {
      if (dialogState.resolve) dialogState.resolve(true)
      dialogState.open = false
    },
    onCancel() {
      if (dialogState.resolve) dialogState.resolve(false)
      dialogState.open = false
    }
  }
}
</script>

<style scoped>
.global-dialog {
  position: fixed;
  inset: 0;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(20, 20, 20, 0.45);
  padding: 20px;
  box-sizing: border-box;
}

.global-dialog-card {
  width: 100%;
  max-width: 360px;
  padding: 28px 24px 20px;
  box-sizing: border-box;
  background-color: var(--surface-card);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  text-align: center;
  font-family: var(--font-sans);
}

.global-dialog-message {
  margin: 0 0 var(--space-8) 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--text-body);
  white-space: pre-line;
}

.global-dialog-actions {
  display: flex;
  gap: var(--space-3);
}

.global-dialog-btn {
  flex: 1;
  height: 44px;
  border-radius: var(--radius-md);
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  font-family: var(--font-sans);
}

.global-dialog-btn--primary {
  border: none;
  background-color: var(--green-500);
  color: var(--white);
}

.global-dialog-btn--primary:hover {
  background-color: var(--green-600);
}

.global-dialog-btn--ghost {
  border: 1px solid var(--ink-200);
  background-color: var(--white);
  color: var(--text-body);
}

.global-dialog-btn--ghost:hover {
  border-color: var(--ink-400);
}
</style>
